import Checkout from './Checkout.vue';

export default Checkout;
